import api from '../../api';
import Logger from '../../../lib/Logger';

import { schema } from '../../schema';
import { addEntities } from '../../actions';
import { normalize } from 'normalizr';

export const TYPES = {
  LIST_TOPIC_REQUEST: 'LEARNING/LIST_TOPIC_REQUEST',
  LIST_TOPIC_SUCCESS: 'LEARNING/LIST_TOPIC_SUCCESS',
  LIST_TOPIC_FAILURE: 'LEARNING/LIST_TOPIC_FAILURE',
  SET_ACTIVE_ITEM_ID: 'LEARNING/SET_ACTIVE_ITEM_ID',
  SET_ACTIVE_ITEM: 'LEARNING/SET_ACTIVE_ITEM',
  SUB_TOPIC_READ_REQUEST: 'LEARNING/SUB_TOPIC_READ_REQUEST',
  SUB_TOPIC_READ_SUCCESS: 'LEARNING/SUB_TOPIC_READ_SUCCESS',
  SUB_TOPIC_READ_FAILURE: 'LEARNING/SUB_TOPIC_READ_FAILURE',
  MODULE_SERIE_LIST_REQUEST: 'LEARNING/MODULE_SERIE_LIST_REQUEST',
  MODULE_SERIE_LIST_SUCCESS: 'LEARNING/MODULE_SERIE_LIST_SUCCESS',
  MODULE_SERIE_LIST_FAILURE: 'LEARNING/MODULE_SERIE_LIST_FAILURE',
  MODULE_LIST_REQUEST: 'LEARNING/MODULE_LIST_REQUEST',
  MODULE_LIST_SUCCESS: 'LEARNING/MODULE_LIST_SUCCESS',
  MODULE_LIST_FAILURE: 'LEARNING/MODULE_LIST_FAILURE',
  MODULE_READ_REQUEST: 'LEARNING/MODULE_READ_REQUEST',
  MODULE_READ_SUCCESS: 'LEARNING/MODULE_READ_SUCCESS',
  MODULE_READ_FAILURE: 'LEARNING/MODULE_READ_FAILURE',
  MODULE_CATEGORY_LIST_REQUEST: 'LEARNING/MODULE_CATEGORY_LIST_REQUEST',
  MODULE_CATEGORY_LIST_SUCCESS: 'LEARNING/MODULE_CATEGORY_LIST_SUCCESS',
  MODULE_CATEGORY_LIST_FAILURE: 'LEARNING/MODULE_CATEGORY_LIST_FAILURE',
  MODULE_LEARNING_STEP_LIST_REQUEST:
    'LEARNING/MODULE_LEARNING_STEP_LIST_REQUEST',
  MODULE_LEARNING_STEP_LIST_SUCCESS:
    'LEARNING/MODULE_LEARNING_STEP_LIST_SUCCESS',
  MODULE_LEARNING_STEP_LIST_FAILURE:
    'LEARNING/MODULE_LEARNING_STEP_LIST_FAILURE',
  MODULE_LEARNING_STEP_READ_REQUEST:
    'LEARNING/MODULE_LEARNING_STEP_READ_REQUEST',
  MODULE_LEARNING_STEP_READ_SUCCESS:
    'LEARNING/MODULE_LEARNING_STEP_READ_SUCCESS',
  MODULE_LEARNING_STEP_READ_FAILURE:
    'LEARNING/MODULE_LEARNING_STEP_READ_FAILURE',
  MODULE_LEARNING_STEP_PATCH_REQUEST:
    'LEARNING/MODULE_LEARNING_STEP_PATCH_REQUEST',
  MODULE_LEARNING_STEP_PATCH_SUCCESS:
    'LEARNING/MODULE_LEARNING_STEP_PATCH_SUCCESS',
  MODULE_LEARNING_STEP_PATCH_FAILURE:
    'LEARNING/MODULE_LEARNING_STEP_PATCH_FAILURE',
  MODULE_LEARNING_VIEW_REQUEST: 'LEARNING/MODULE_LEARNING_VIEW_REQUEST',
  MODULE_LEARNING_VIEW_SUCCESS: 'LEARNING/MODULE_LEARNING_VIEW_SUCCESS',
  MODULE_LEARNING_VIEW_FAILURE: 'LEARNING/MODULE_LEARNING_VIEW_FAILURE',
  MODULE_LEARNING_VIEW_PATCH_REQUEST:
    'LEARNING/MODULE_LEARNING_VIEW_PATCH_REQUEST',
  MODULE_LEARNING_VIEW_PATCH_SUCCESS:
    'LEARNING/MODULE_LEARNING_VIEW_PATCH_SUCCESS',
  MODULE_LEARNING_VIEW_PATCH_FAILURE:
    'LEARNING/MODULE_LEARNING_VIEW_PATCH_FAILURE',
};

export function setActiveItemId(id) {
  Logger.log('debug', `[state.subTopic.actions] setActiveItemId(${id})`);
  return {
    type: TYPES.SET_ACTIVE_ITEM_ID,
    id: id,
  };
}

export function setActiveItem(activeItem) {
  Logger.log('debug', `[state.subTopic.actions] setActiveItem(${activeItem})`);
  return {
    type: TYPES.SET_ACTIVE_ITEM,
    activeItem: activeItem,
  };
}

export function subTopicReadRequest(id) {
  Logger.log('debug', `[resourcesAdmin.actions] subTopicReadRequest(${id})`);
  return {
    type: TYPES.SUB_TOPIC_READ_REQUEST,
    id: id,
  };
}

export function subTopicReadSuccess(data) {
  Logger.log('debug', `[resourcesAdmin.actions] subTopicReadSuccess(%j)`, data);
  return {
    type: TYPES.SUB_TOPIC_READ_SUCCESS,
    id: data.id,
    result: data.result,
    receivedAt: Date.now(),
  };
}

export function subTopicReadFailure(error) {
  Logger.log(
    'debug',
    `[resourcesAdmin.actions] subTopicReadFailure(%j)`,
    error
  );
  return {
    type: TYPES.SUB_TOPIC_READ_FAILURE,
    error: error,
  };
}

export function learningListTopicsRequest(page, limit) {
  Logger.log(
    'debug',
    `[state.learnings.actions] learningListTopicsRequest(${page}, ${limit}, %j)`
  );
  return {
    type: TYPES.LIST_TOPIC_REQUEST,
    page: page,
    limit: limit,
  };
}

export function learningListTopicsSuccess(data) {
  Logger.log(
    'debug',
    `[state.learnings.actions] learningListTopicsSuccess(%j)`,
    data
  );
  return {
    type: TYPES.LIST_TOPIC_SUCCESS,
    page: data.page,
    limit: data.limit,
    result: data.result,
    page_count: data.page_count,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function learningListTopicsFailure(error) {
  Logger.log(
    'debug',
    `[state.learnings.actions] learningListTopicsFailure(%j)`,
    error
  );
  return {
    type: TYPES.LIST_TOPIC_FAILURE,
    error: error,
  };
}

export function moduleSerieListRequest(
  careGuideId,
  partnershipId,
  action,
  page,
  limit,
  order
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleSerieListRequest(${careGuideId}, ${partnershipId}, ${action}, ${page}, ${limit}, ${order})`
  );
  return {
    type: TYPES.MODULE_SERIE_LIST_REQUEST,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
    action: action,
    page: page,
    limit: limit,
    order: order,
  };
}

export function moduleSerieListSuccess(
  careGuideId,
  partnershipId,
  action,
  data
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleSerieListSuccess(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_LIST_SUCCESS,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
    action: action,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function moduleSerieListFailure(
  careGuideId,
  partnershipId,
  action,
  error
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleSerieListFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_SERIE_LIST_FAILURE,
    error: error,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
    action: action,
  };
}

export function moduleListRequest(
  careGuideId,
  moduleSerieId,
  action,
  page,
  limit,
  order
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleListRequest(${careGuideId}, ${moduleSerieId}, ${action}, ${page}, ${limit}, ${order})`
  );
  return {
    type: TYPES.MODULE_LIST_REQUEST,
    moduleSerieId: moduleSerieId,
    careGuideId: careGuideId,
    action: action,
    page: page,
    limit: limit,
    order: order,
  };
}

export function moduleListSuccess(careGuideId, moduleSerieId, action, data) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleListSuccess(${careGuideId}, ${moduleSerieId}, ${action}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_LIST_SUCCESS,
    careGuideId: careGuideId,
    moduleSerieId: moduleSerieId,
    action: action,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function moduleListFailure(careGuideId, moduleSerieId, action, error) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleListFailure(${careGuideId}, ${moduleSerieId}, ${action}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_LIST_FAILURE,
    error: error,
    careGuideId: careGuideId,
    moduleSerieId: moduleSerieId,
    action: action,
  };
}

export function moduleCategoryListRequest(
  partnershipId,
  careGuideId,
  page,
  limit,
  order
) {
  Logger.log(
    'debug',
    `[state.recommendedUtilities.actions] moduleCategoryListRequest(${partnershipId}, ${careGuideId}, ${page}, ${limit}, ${order})`
  );
  return {
    type: TYPES.MODULE_CATEGORY_LIST_REQUEST,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
    page: page,
    limit: limit,
    order: order,
  };
}

export function moduleCategoryListSuccess(careGuideId, partnershipId, data) {
  Logger.log(
    'debug',
    `[state.recommendedUtilities.actions] moduleCategoryListSuccess(${careGuideId}, ${partnershipId}, %j)`,
    data
  );

  return {
    type: TYPES.MODULE_CATEGORY_LIST_SUCCESS,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function moduleCategoryListFailure(careGuideId, partnershipId, error) {
  Logger.log(
    'debug',
    `[state.recommendedUtilities.actions] moduleCategoryListFailure(${careGuideId}, ${partnershipId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_CATEGORY_LIST_FAILURE,
    careGuideId: careGuideId,
    partnershipId: partnershipId,
    error: error,
  };
}

export function moduleReadRequest(careGuideId, id) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleReadRequest(${careGuideId}, ${id})`
  );
  return {
    type: TYPES.MODULE_READ_REQUEST,
    id: id,
    careGuideId: careGuideId,
  };
}

export function moduleReadSuccess(careGuideId, data) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleReadSuccess(${careGuideId},%j)`,
    data
  );
  return {
    type: TYPES.MODULE_READ_SUCCESS,
    id: data.id,
    careGuideId: careGuideId,
    receivedAt: Date.now(),
  };
}

export function moduleReadFailure(careGuideId, error) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleReadFailure(${careGuideId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_READ_FAILURE,
    error: error,
    careGuideId: careGuideId,
  };
}

export function moduleLearningStepListRequest(
  careGuideId,
  moduleId,
  page,
  limit,
  order
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningStepListRequest(${careGuideId}, ${moduleId}, ${page}, ${limit}, ${order})`
  );
  return {
    type: TYPES.MODULE_LEARNING_STEP_LIST_REQUEST,
    moduleId: moduleId,
    careGuideId: careGuideId,
    page: page,
    limit: limit,
    order: order,
  };
}

export function moduleLearningStepListSuccess(careGuideId, moduleId, data) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningStepListSuccess(%j)`,
    data
  );

  return {
    type: TYPES.MODULE_LEARNING_STEP_LIST_SUCCESS,
    careGuideId: careGuideId,
    moduleId: moduleId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function moduleLearningStepListFailure(careGuideId, moduleId, error) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningStepListFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_LEARNING_STEP_LIST_FAILURE,
    error: error,
    careGuideId: careGuideId,
    moduleId: moduleId,
  };
}

export function moduleLearningStepReadRequest(careGuideId, moduleStepId) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningStepReadRequest(${careGuideId}, ${moduleStepId})`
  );
  return {
    type: TYPES.MODULE_LEARNING_STEP_READ_REQUEST,
    id: moduleStepId,
    careGuideId: careGuideId,
  };
}

export function moduleLearningStepReadSuccess(careGuideId, moduleStepId, data) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningStepReadSuccess(${careGuideId}, ${moduleStepId}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_LEARNING_STEP_READ_SUCCESS,
    id: moduleStepId,
    careGuideId: careGuideId,
    receivedAt: Date.now(),
  };
}

export function moduleLearningStepReadFailure(
  careGuideId,
  moduleStepId,
  error
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningStepReadFailure(${careGuideId}, ${moduleStepId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_LEARNING_STEP_READ_FAILURE,
    error: error,
    careGuideId: careGuideId,
    id: moduleStepId,
  };
}

export function moduleLearningStepPatchRequest(careGuideId, id, data) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningStepPatchRequest(${careGuideId}, ${id}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_LEARNING_STEP_PATCH_REQUEST,
    careGuideId: careGuideId,
    id: id,
  };
}

export function moduleLearningStepPatchSuccess(careGuideId, id, data) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningStepPatchSuccess(${careGuideId}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_LEARNING_STEP_PATCH_SUCCESS,
    careGuideId: careGuideId,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function moduleLearningStepPatchFailure(careGuideId, error) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningStepPatchFailure(${careGuideId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_LEARNING_STEP_PATCH_FAILURE,
    careGuideId: careGuideId,
    error: error,
  };
}

export function moduleLearningViewRequest(moduleId) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningViewRequest(${moduleId})`
  );
  return {
    type: TYPES.MODULE_LEARNING_VIEW_REQUEST,
    moduleId: moduleId,
  };
}

export function moduleLearningViewSuccess(moduleId) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningViewSuccess(${moduleId})`
  );
  return {
    type: TYPES.MODULE_LEARNING_VIEW_SUCCESS,
    moduleId: moduleId,
    receivedAt: Date.now(),
  };
}

export function moduleLearningViewFailure(moduleId, error) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningViewFailure(${moduleId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_LEARNING_VIEW_FAILURE,
    moduleId: moduleId,
    error: error,
  };
}

export function moduleLearningViewPatchRequest(moduleId, data) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningViewPatchRequest(${moduleId}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_LEARNING_VIEW_PATCH_REQUEST,
    moduleId: moduleId,
  };
}

export function moduleLearningViewPatchSuccess(moduleId, data) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningViewPatchSuccess(${moduleId}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_LEARNING_VIEW_PATCH_SUCCESS,
    moduleId: moduleId,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function moduleLearningViewPatchFailure(moduleId, error) {
  Logger.log(
    'debug',
    `[state.learnings.actions] moduleLearningViewPatchFailure(${moduleId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_LEARNING_VIEW_PATCH_FAILURE,
    moduleId: moduleId,
    error: error,
  };
}

// API THUNK ACTION CREATORS

export function loadTopics(plan_name, page, limit, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learnings.actions] loadTopics(${page}, ${limit}, %j, ###)`
  );
  return async function (dispatch) {
    dispatch(learningListTopicsRequest(page, limit));

    // call API
    const response = await api.getTopics(plan_name, page, limit);
    let success = false;

    // get topics list success
    if (
      200 === response.get('status') &&
      response.getIn(['data', 'data']).length !== 0
    ) {
      Logger.log(
        'info',
        `Get API topics list success. Page: ${page}, Limit: ${limit}`
      );
      const meta = response.getIn(['data', 'meta']);
      const data = {
        page: meta.pagination.page,
        limit: meta.pagination.pageSize,
        page_count: meta.pagination.pageCount,
        total: meta.pagination.page,
        result: response.getIn(['data', 'data']),
      };

      dispatch(learningListTopicsSuccess(data));
      success = true;
    } else if (
      1 === page &&
      200 === response.get('status') &&
      response.getIn(['data', 'data']).length === 0
    ) {
      Logger.log(
        'info',
        `Get API topics list success [empty]. Page: ${page}, Limit: ${limit}`
      );

      const data = {
        page: page,
        limit: limit,
        page_count: 0,
        result: [],
      };
      dispatch(setActiveItemId(null));
      dispatch(setActiveItem(null));
      dispatch(learningListTopicsSuccess(data));
      success = true;

      // get topics list failure
    } else {
      const data = {
        page: page,
        limit: limit,
        page_count: 0,
        result: [],
      };
      dispatch(learningListTopicsSuccess(data));
      dispatch(setActiveItemId(null));
      dispatch(setActiveItem(null));
      Logger.log(
        'info',
        `Get API topics list failure. Page: ${page}, Limit: ${limit}`
      );
      dispatch(moduleSerieListFailure(response.getIn(['data', 'error'])));
    }
    // callback function
    cb(success);
  };
}

export function loadModuleSeries(
  careGuideId,
  partnershipId,
  action,
  filter,
  page,
  limit,
  order,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] loadModuleSeries(${careGuideId}, ${partnershipId}, ${action}, ${page}, ${limit}, ${order}, %j)`,
    filter
  );

  return async function (dispatch) {
    dispatch(
      moduleSerieListRequest(
        careGuideId,
        partnershipId,
        action,
        page,
        limit,
        order
      )
    );
    // call API
    const response = await api.getModuleSeries(
      careGuideId,
      partnershipId,
      filter,
      page,
      limit,
      order
    );
    let success = false;
    let total = 0;

    // get module serie list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module serie list success. Care Guide ID: ${careGuideId}, Plan ID: ${partnershipId}, Action: ${action}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'module_series']),
        [schema.learningModuleSerie]
      );

      total = response.getIn(['data', 'total']);

      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(
        moduleSerieListSuccess(careGuideId, partnershipId, action, data)
      );
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module serie list success [empty]. Care Guide ID: ${careGuideId}, Partnership ID: ${partnershipId}, Action: ${action}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };

      dispatch(
        moduleSerieListSuccess(careGuideId, partnershipId, action, data)
      );
      success = true;

      // get module serie list failure
    } else {
      Logger.log(
        'info',
        `Get API module serie list failure. Care Guide ID: ${careGuideId}, Partnership ID: ${partnershipId}, Action: ${action}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        moduleSerieListFailure(
          careGuideId,
          partnershipId,
          action,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success, total);
  };
}

export function loadModules(
  careGuideId,
  moduleSerieId,
  action,
  filter,
  page,
  limit,
  order,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] loadModuleSeries(${careGuideId}, ${moduleSerieId}, ${action}, ${page}, ${limit}, ${order}, %j)`,
    filter
  );

  return async function (dispatch) {
    dispatch(
      moduleListRequest(careGuideId, moduleSerieId, action, page, limit, order)
    );
    // call API
    const response = await api.getModules(
      careGuideId,
      moduleSerieId,
      filter,
      page,
      limit,
      order
    );
    let success = false;
    let total = 0;

    // get module serie list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module serie list success. Care Guide ID: ${careGuideId}, Module Serie ID: ${moduleSerieId}, Action: ${action}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'modules']),
        [schema.learningModule]
      );

      total = response.getIn(['data', 'total']);

      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleListSuccess(careGuideId, moduleSerieId, action, data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module serie list success [empty]. Care Guide ID: ${careGuideId}, Module Serie ID: ${moduleSerieId}, Action: ${action}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };

      dispatch(moduleListSuccess(careGuideId, moduleSerieId, action, data));
      success = true;

      // get module serie list failure
    } else {
      Logger.log(
        'info',
        `Get API module serie list failure. Care Guide ID: ${careGuideId}, Module Serie ID: ${moduleSerieId}, Action: ${action}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        moduleListFailure(
          careGuideId,
          moduleSerieId,
          action,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success, total);
  };
}

export function loadModule(careGuideId, id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learnings.actions] loadModule(${careGuideId}, ${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(moduleReadRequest(careGuideId, id));

    // call API
    const response = await api.getModule(careGuideId, id);
    let success = false;

    // get module success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module success. Care Guide ID: ${careGuideId}, ID: ${id}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module'])],
        [schema.learningModule]
      );

      const data = {
        id: response.getIn(['data', 'module', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleReadSuccess(careGuideId, id, data));
      success = true;

      // get module failure
    } else {
      Logger.log(
        'info',
        `Get API module failure. Care Guide ID: ${careGuideId}, ID: ${id}.`
      );
      dispatch(
        moduleReadFailure(careGuideId, id, response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function loadModuleCategories(
  careGuideId,
  partnershipId,
  page,
  limit,
  order,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] loadModuleCategories ${partnershipId}, ${careGuideId}, ${page}, ${limit}, ${order})`
  );
  return async function (dispatch) {
    dispatch(
      moduleCategoryListRequest(partnershipId, careGuideId, page, limit, order)
    );

    // call API
    const response = await api.getModuleCategories(
      careGuideId,
      partnershipId,
      page,
      limit,
      order
    );
    let success = false;
    let total = 0;
    // get module category list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module category list success. Care Guide ID: ${careGuideId}, Plan ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'module_categories']),
        [schema.learningModuleCategory]
      );

      total = response.getIn(['data', 'total']);
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleCategoryListSuccess(careGuideId, partnershipId, data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module category list success [empty]. Care Guide ID: ${careGuideId}, Plan ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };

      dispatch(moduleCategoryListSuccess(careGuideId, partnershipId, data));
      success = true;

      // get module category list failure
    } else {
      Logger.log(
        'info',
        `Get API module category list failure. Care Guide ID: ${careGuideId}, Plan ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        moduleCategoryListFailure(
          careGuideId,
          partnershipId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success, total);
  };
}

export function loadModuleLearningSteps(
  careGuideId,
  moduleId,
  page,
  limit,
  order,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] loadModuleLearningSteps(${careGuideId}, ${moduleId}, ${page}, ${limit}, ${order})`
  );
  return async function (dispatch) {
    dispatch(
      moduleLearningStepListRequest(careGuideId, moduleId, page, limit, order)
    );

    // call API
    const response = await api.getModuleLearningSteps(
      careGuideId,
      moduleId,
      page,
      limit,
      order
    );
    let success = false;
    let total = 0;
    // get module step list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module step list success. Care Guide ID: ${careGuideId}, Module ID: ${moduleId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'module_steps']),
        [schema.learningModuleLearningStep]
      );

      total = response.getIn(['data', 'total']);
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleLearningStepListSuccess(careGuideId, moduleId, data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module step list success [empty]. Care Guide ID: ${careGuideId}, Module ID: ${moduleId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };

      dispatch(moduleLearningStepListSuccess(careGuideId, moduleId, data));
      success = true;

      // get module step list failure
    } else {
      Logger.log(
        'info',
        `Get API module step list failure. Care Guide ID: ${careGuideId}, Module ID: ${moduleId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        moduleLearningStepListFailure(
          careGuideId,
          moduleId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success, total);
  };
}

export function loadModuleLearningStep(careGuideId, id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learnings.actions] loadModuleLearningStep(${careGuideId},${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(moduleLearningStepReadRequest(careGuideId, id));

    // call API
    const response = await api.getModuleLearningStep(careGuideId, id);
    let success = false;

    // get module step success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module step success. Care Guide ID: ${careGuideId}, ID: ${id}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module_step'])],
        [schema.learningModuleLearningStep]
      );

      const data = {
        id: response.getIn(['data', 'module_step', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleLearningStepReadSuccess(careGuideId, id, data));
      success = true;

      // get module step failure
    } else {
      Logger.log(
        'info',
        `Get API module failure. Care Guide ID: ${careGuideId}, ID: ${id}.`
      );
      dispatch(
        moduleLearningStepReadFailure(
          careGuideId,
          id,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function patchModuleLearningStep(
  careGuideId,
  id,
  data,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learnings.actions] patchModuleLearningStep(${careGuideId},${id}, %j)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleLearningStepPatchRequest(careGuideId, id, data));

    // call API
    const response = await api.patchModuleLearningStep(careGuideId, id, data);
    let success = false;

    // patch module step success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `PATCH API module step success. Care Guide ID: ${careGuideId}, Module Step ID: ${id}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module_step'])],
        [schema.learningModuleLearningStep]
      );
      const data = {
        id: response.getIn(['data', 'module_step', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleLearningStepPatchSuccess(careGuideId, id, data));
      success = true;

      // patch module step failure
    } else {
      Logger.log(
        'info',
        `PATCH API module step failure. Care Guide ID: ${careGuideId}, Module Step ID: ${id}.`
      );
      dispatch(
        moduleLearningStepPatchFailure(
          careGuideId,
          id,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function createModuleView(moduleId, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] createModuleView(${moduleId}, ###)`
  );

  return async function (dispatch) {
    dispatch(moduleLearningViewRequest(moduleId));

    // call API
    const response = await api.postModuleView(moduleId);
    let success = false;

    // post module view success
    if (201 === response.get('status')) {
      Logger.log('info', `POST API module view success.`);

      dispatch(moduleLearningViewSuccess(moduleId));
      success = true;
    } else {
      // get module view failure
      Logger.log('info', `POST API module view failure.`);
      dispatch(
        moduleLearningViewFailure(moduleId, response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function patchModuleView(moduleId, data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learnings.actions] patchModuleView(${moduleId}, %j)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleLearningViewPatchRequest(moduleId, data));

    // call API
    const response = await api.patchModuleView(moduleId, data);
    let success = false;

    // patch module view success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `PATCH API module view success. Module ID: ${moduleId}`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module'])],
        [schema.learningModule]
      );
      const data = {
        id: response.getIn(['data', 'module', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleLearningViewPatchSuccess(moduleId, data));
      success = true;

      // patch module view failure
    } else {
      Logger.log(
        'info',
        `PATCH API module view failure. Module ID: ${moduleId}`
      );
      dispatch(
        moduleLearningViewPatchFailure(
          moduleId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}
